import type { ValidationError } from '@tanstack/react-form';
import React, { ChangeEventHandler } from 'react';
import { classNames } from '@utils/classNames';

export default function TextAreaInput({
  label,
  value,
  errors,
  handleBlur,
  handleChange,
  id,
  name,
  containerClassName,
  inputClassName,
  disabled,
  testId,
}: Readonly<{
  label: string;
  value: string;
  errors?: ValidationError[];
  handleBlur: (e: React.FocusEvent<never>) => void;
  handleChange: ChangeEventHandler<HTMLTextAreaElement>;
  name: string;
  id: string;
  containerClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  testId?: string;
}>) {
  const relevantErrors =
    errors?.filter((error): error is string => !!error) ?? [];

  return (
    <div
      className={classNames(
        'flex flex-col w-full space-y-2',
        containerClassName,
      )}
    >
      <label
        htmlFor={id}
        className={classNames(
          'font-bold',
          disabled ? 'text-grey1' : 'text-dark',
        )}
      >
        {label}
      </label>
      <textarea
        id={id}
        name={name}
        className={classNames(
          'text-sm font-light min-h-[120px] px-4 py-3 rounded-bonusLarge bg-grey3light',
          'focus:border-2 focus:border-ivarioBlue',
          'resize-none',
          !disabled && relevantErrors.length ? 'border-2 border-error' : '',
          disabled ? 'bg-grey3light-50 text-grey1' : 'text-dark',
          'placeholder:text-grey1 placeholder:text-sm placeholder:font-light',
          inputClassName,
        )}
        onInput={handleChange}
        onBlur={handleBlur}
        value={value}
        disabled={disabled}
        data-testid={testId}
      />
      {!disabled &&
        !!relevantErrors.length &&
        relevantErrors.map((error) => (
          <p className="text-error" key={error.toString()}>
            {error}
          </p>
        ))}
    </div>
  );
}
